import { FeatureFlag } from '../FeatureFlag';

export const enableCommandPalette = new FeatureFlag({
    key: 'enable-command-palette',
    createdOn: '2026-03-09',
    defaultValue: false,
});
